import { render } from "./ContentFooter.vue?vue&type=template&id=9cecfda4"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import "./ContentFooter.vue?vue&type=style&index=0&id=9cecfda4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__